function createToc(options = {}) {
  const {
    tocSelector = ".js-toc",
    contentSelector = ".js-toc-content",
    headingSelector = ".js-toc-heading",
    textSelector = ".js-toc-text",
    idPrefix = "toc",
    clearToc = true,
    itemClass = "c-toc__item",
    currentClass = "is-current",
    setFirstCurrent = true,

    observeScroll = true,
    rootMarginTop = -80,
    rootMarginBottom = -60,
    threshold = [0, 1],

    currentTextSelector = ".js-toc-current",
    mobileMedia = "(max-width: 767px)",
    currentTextJoiner = "",

    headingLabelSelector = ".js-toc-heading-label",
    prependHeadingOnMobile = true,
    headingItemClass = "c-toc__item c-toc__item--heading",

    mobileWrapperSelector = ".c-toc__mobile-wrapper",
    mobileListWrapperSelector = ".c-toc__list-wrapper",
    mobileToggleStateKey = "toggle",
    mobileScrollOffset = 80,
    collapseFallbackDelay = 10,
  } = options;

  const toc = document.querySelector(tocSelector);
  const content = document.querySelector(contentSelector);
  if (!toc || !content) return null;

  const tocRoot = toc.closest(".c-toc") || toc.parentElement;

  const headings = Array.from(content.querySelectorAll(headingSelector));
  if (!headings.length) return { toc, headings, destroy: () => {} };

  if (clearToc) toc.innerHTML = "";

  const usedIds = new Set(
    Array.from(document.querySelectorAll("[id]"))
      .map((el) => el.id)
      .filter(Boolean),
  );

  const ensureId = (el, index) => {
    if (el.id && !usedIds.has(el.id)) {
      usedIds.add(el.id);
      return el.id;
    }
    if (el.id && usedIds.has(el.id)) el.id = "";

    let id = `${idPrefix}${index + 1}`;
    let n = 2;
    while (usedIds.has(id)) id = `${idPrefix}${index + 1}-${n++}`;
    el.id = id;
    usedIds.add(id);
    return id;
  };

  const getHeadingLabel = (heading) => {
    const dataToc = heading.getAttribute("data-toc");
    if (dataToc && dataToc.trim()) {
      return dataToc.replace(/\s+/g, " ").trim();
    }

    const textEl = heading.querySelector(textSelector);
    const raw = textEl ? textEl.textContent : heading.textContent;
    return String(raw || "")
      .replace(/\s+/g, " ")
      .trim();
  };

  const idToLi = new Map();
  const idToLabel = new Map();
  let firstId = null;

  headings.forEach((heading, i) => {
    const label = getHeadingLabel(heading);
    if (!label) return;

    const id = ensureId(heading, i);
    if (!firstId) firstId = id;

    const li = document.createElement("li");
    li.className = itemClass;

    const a = document.createElement("a");
    a.href = `#${id}`;
    a.textContent = label;

    li.appendChild(a);
    toc.appendChild(li);

    idToLi.set(id, li);
    idToLabel.set(id, label);
  });

  const currentTextEl =
    tocRoot?.querySelector(currentTextSelector) ||
    document.querySelector(currentTextSelector);
  const mql = window.matchMedia ? window.matchMedia(mobileMedia) : null;
  const mobileHeadingId = "__toc_mobile_heading__";

  const getHeadingTopLabel = () => {
    const headingEl =
      tocRoot?.querySelector(headingLabelSelector) ||
      document.querySelector(headingLabelSelector);

    if (!headingEl) return "";
    return headingEl.textContent.replace(/\s+/g, " ").trim();
  };

  const updateMobileHeadingItem = () => {
    if (!prependHeadingOnMobile || !mql) return;

    const existing = toc.querySelector(".js-toc-mobile-heading-item");
    if (existing) existing.remove();

    if (!mql.matches) return;

    const label = getHeadingTopLabel();
    if (!label) return;

    const li = document.createElement("li");
    li.className = `${headingItemClass} js-toc-mobile-heading-item`;
    li.dataset.tocId = mobileHeadingId;

    const span = document.createElement("span");
    span.className = "c-toc__text";
    span.textContent = label;

    li.appendChild(span);
    toc.prepend(li);
  };

  const updateCurrentText = (id) => {
    if (!currentTextEl) return;
    const isMobile = mql ? mql.matches : false;
    if (!isMobile) return;

    let label = "";

    if (id === mobileHeadingId) {
      label = getHeadingTopLabel();
    } else {
      label = idToLabel.get(id) || "";
    }

    currentTextEl.textContent = currentTextJoiner
      ? `${currentTextJoiner}${label}`
      : label;
  };

  const setCurrentById = (id) => {
    idToLi.forEach((li) => li.classList.remove(currentClass));

    const mobileHeadingItem = toc.querySelector(".js-toc-mobile-heading-item");
    if (mobileHeadingItem) {
      mobileHeadingItem.classList.remove(currentClass);
    }

    if (id === mobileHeadingId) {
      if (mobileHeadingItem) mobileHeadingItem.classList.add(currentClass);
      updateCurrentText(id);
      return;
    }

    const target = idToLi.get(id);
    if (target) target.classList.add(currentClass);
    updateCurrentText(id);
  };

  const setCurrentBeforeFirstHeading = () => {
    if (!mql?.matches || !firstId) return false;

    const firstHeading = document.getElementById(firstId);
    if (!firstHeading) return false;

    const triggerY = Math.abs(rootMarginTop) + 1;
    const firstTop = firstHeading.getBoundingClientRect().top;

    if (firstTop > triggerY) {
      setCurrentById(mobileHeadingId);
      return true;
    }

    return false;
  };

  const getHeaderOffset = () => {
    const header =
      document.querySelector(".js-header") ||
      document.querySelector(".l-header") ||
      document.querySelector("header");

    return header ? header.offsetHeight : 0;
  };

  const scrollToHeading = (target) => {
    const top =
      target.getBoundingClientRect().top +
      window.pageYOffset -
      getHeaderOffset() -
      mobileScrollOffset;

    window.scrollTo({
      top,
      behavior: "smooth",
    });
  };

  const closeMobileTocAndScroll = (target) => {
    const mobileWrapper = tocRoot?.querySelector(mobileWrapperSelector);
    const listWrapper = tocRoot?.querySelector(mobileListWrapperSelector);

    if (!mobileWrapper || !listWrapper || !mql?.matches) {
      scrollToHeading(target);
      return;
    }

    const dataStack = mobileWrapper._x_dataStack;
    const state = dataStack?.[0];

    if (!state || !(mobileToggleStateKey in state)) {
      scrollToHeading(target);
      return;
    }

    if (!state[mobileToggleStateKey]) {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          scrollToHeading(target);
        });
      });
      return;
    }

    let done = false;

    const finish = () => {
      if (done) return;
      done = true;
      listWrapper.removeEventListener("transitionend", onEnd);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          scrollToHeading(target);
        });
      });
    };

    const onEnd = (e) => {
      if (e.target !== listWrapper) return;
      finish();
    };

    listWrapper.addEventListener("transitionend", onEnd);
    state[mobileToggleStateKey] = false;

    setTimeout(finish, collapseFallbackDelay);
  };

  updateMobileHeadingItem();

  if (setFirstCurrent && firstId) {
    if (!setCurrentBeforeFirstHeading()) {
      setCurrentById(firstId);
    }
  }

  toc.addEventListener("click", (e) => {
    const a = e.target.closest("a");
    if (!a) return;

    const id = a.getAttribute("href")?.replace(/^#/, "");
    if (!id) return;

    const target = document.getElementById(id);
    if (!target) return;

    e.preventDefault();

    if (mql?.matches) {
      closeMobileTocAndScroll(target);
    } else {
      scrollToHeading(target);
    }
  });

  if (mql) {
    const onChange = () => {
      updateMobileHeadingItem();

      if (setCurrentBeforeFirstHeading()) return;

      const currentLi = toc.querySelector(`.${currentClass} a`);
      const id = currentLi?.getAttribute("href")?.replace(/^#/, "");
      if (id) updateCurrentText(id);
      else if (firstId) updateCurrentText(firstId);
    };

    if (mql.addEventListener) mql.addEventListener("change", onChange);
    else if (mql.addListener) mql.addListener(onChange);
  }

  let observer = null;
  if (observeScroll && "IntersectionObserver" in window) {
    const visible = new Set();

    const pickCurrent = () => {
      if (setCurrentBeforeFirstHeading()) return;

      if (!visible.size) {
        const y = window.scrollY + Math.abs(rootMarginTop) + 1;
        let current = firstId;
        for (const h of headings) {
          if (!h.id) continue;
          if (h.offsetTop <= y) current = h.id;
        }
        if (current) setCurrentById(current);
        return;
      }

      let topMost = null;
      let top = Infinity;
      visible.forEach((id) => {
        const el = document.getElementById(id);
        if (!el) return;
        const r = el.getBoundingClientRect();
        if (r.top < top) {
          top = r.top;
          topMost = id;
        }
      });
      if (topMost) setCurrentById(topMost);
    };

    observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          const id = entry.target.id;
          if (!id) continue;
          if (entry.isIntersecting) visible.add(id);
          else visible.delete(id);
        }
        pickCurrent();
      },
      {
        root: null,
        rootMargin: `${rootMarginTop}px 0px ${rootMarginBottom}px 0px`,
        threshold,
      },
    );

    headings.forEach((h) => {
      if (h.id) observer.observe(h);
    });

    setTimeout(() => {
      updateMobileHeadingItem();

      const hash = location.hash.replace("#", "");
      if (hash && idToLi.has(hash)) {
        setCurrentById(hash);
      } else if (setFirstCurrent && firstId) {
        if (!setCurrentBeforeFirstHeading()) {
          setCurrentById(firstId);
        }
      }
    }, 0);
  }

  return {
    toc,
    headings,
    destroy: () => {
      if (observer) observer.disconnect();
    },
  };
}
